var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "task__field__labels" } },
    [
      _vm.tasks.length > 0
        ? _c(
            "div",
            { staticClass: "field-block d-flex flex-row" },
            [
              _c(
                "draggable",
                {
                  staticClass: "d-flex flex-row sortable--fields",
                  attrs: {
                    draggable: ".draggable-field",
                    filter: ".no-draggable-field",
                    move: _vm.checkMoveField,
                    handle: ".field-move-handle",
                    disabled: true
                  },
                  on: { update: _vm.moveField },
                  model: {
                    value: _vm.taskFieldOrder,
                    callback: function($$v) {
                      _vm.taskFieldOrder = $$v
                    },
                    expression: "taskFieldOrder"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "field-control-wrapper field-control-wrapper__title no-radius no-draggable-field",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("div", { staticClass: "task-title" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "az task-table-header__task exclude-outside-click cursor-pointer",
                            class:
                              _vm.$store.state.deliverables.storedSortKey ==
                              "created_date"
                                ? _vm.$store.state.deliverables
                                    .storedSortState + "-created-date"
                                : ""
                          },
                          [
                            _vm._v("\n              Tasks "),
                            _c("span", { staticClass: "task-count-second" }, [
                              _vm._v("(" + _vm._s(_vm.tasks.length) + ")")
                            ]),
                            _vm._v(" "),
                            !(
                              !_vm.userAbilities.editMediaCall ||
                              (_vm.deliverable &&
                                _vm.deliverable.permissions &&
                                _vm.deliverable.permissions.viewOnly)
                            )
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "add-task-btn",
                                    attrs: { variant: "theme" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.createTask.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Add Task\n                  "
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.addingTask,
                                            expression: "addingTask"
                                          }
                                        ],
                                        staticClass:
                                          "ml-2 spinner-border spinner-border-sm text-primary",
                                        attrs: { role: "status" }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Loading...")
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.tasks[0].taskFields, function(taskField, index) {
                    return _c(
                      "div",
                      {
                        key:
                          taskField.field_key +
                          "_" +
                          taskField.field_id +
                          index,
                        staticClass:
                          "d-none d-lg-block field-rows field-control-wrapper draggable-field",
                        class: _vm.getClasses(taskField)
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "task-table-header",
                            class: _vm.getSortingClass(taskField.field_id)
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field-label cursor-pointer" },
                              [
                                taskField.label_id !== null
                                  ? _c(
                                      "div",
                                      [
                                        _c("NewCustomFieldLabel", {
                                          attrs: {
                                            customField: taskField,
                                            taskCount: _vm.tasks.length,
                                            deliverableId: _vm.deliverableId,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(taskField.label) +
                                          "\n            "
                                      )
                                    ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("AdditionalFields", {
        attrs: {
          deliverableType: _vm.deliverable.deliverable_template_id,
          deliverableId: _vm.deliverableId,
          namespace: _vm.namespace
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }